import { useCallback, useEffect, useState } from 'react'
import { Button, ButtonGroup, Card, Dropdown } from 'react-bootstrap'
import { PageContainer, StyledTable } from './styles'
import Cookies from 'js-cookie'
import config from '../../config'
import { Pagination } from './components/Pagination'
import Swal from 'sweetalert2'
import moment from 'moment'
import CreateCouponModal from './components/Modal'
import { formatComma } from '../../helpers/helpers'
import DownloadModal from './components/DownloadModal'

const Coupon = () => {
  const [couponDetail, setCouponDetail] = useState()
  const [searchParam, setSearchParam] = useState({ page: 1, couponType: '' })
  const [hasNextPage, setHasNextPage] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showDownloadModal, setShowDownloadModal] = useState(false)

  const COUPON_TYPE = ['WALLET', 'SAFE', 'ALL']

  const customizeModal = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    })
  }

  const fetchCoupon = useCallback(async () => {
    try {
      const response = await fetch(
        `${config.apiAdminGateway}/api/v1/admin/coupons?couponType=${
          searchParam.couponType ? searchParam.couponType : 'UNKNOWN'
        }&page=${searchParam.page}&limit=10&sort=UNKONWN`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
            'Content-Type': 'application/json',
          },
        },
      ).then((res) => res.json())
      setCouponDetail(response.data)
      setHasNextPage(response.pagination.hasNext)
    } catch (error) {
      console.log(error)
    }
  }, [searchParam])

  useEffect(() => {
    fetchCoupon()
  }, [fetchCoupon])

  const createCouponByType = async (couponDetail) => {
    if (couponDetail.couponType === 'SAFE' && (!couponDetail.amount || !couponDetail.count)) {
      customizeModal('สร้างคูปองไม่สำเร็จ', 'เกิดข้อผิดพลาดในการสร้างคูปอง กรุณาตรวจสอบความถูกต้องของข้อมูล', 'error')
    } else if (
      couponDetail.couponType === 'WALLET' &&
      (!couponDetail.userNo || !couponDetail.amount || !couponDetail.count)
    ) {
      customizeModal('สร้างคูปองไม่สำเร็จ', 'เกิดข้อผิดพลาดในการสร้างคูปอง กรุณาตรวจสอบความถูกต้องของข้อมูล', 'error')
    } else {
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/coupons`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(couponDetail),
        }).then((res) => res.json())

        if (response.status.code === 100002) throw new Error('Insufficient wallet balance')
        if (response.status.code !== 0) throw new Error('Error create coupon')

        customizeModal('สร้างคูปองสำเร็จ', '', 'success')
      } catch (error) {
        if (error.message === 'Insufficient wallet balance') {
          customizeModal('สร้างคูปองไม่สำเร็จ', 'จำนวนแคชไม่เพียงพอในการสร้างคูปอง', 'error')
        } else {
          customizeModal('สร้างคูปองไม่สำเร็จ', 'เกิดข้อผิดพลาดในการสร้างคูปอง', 'error')
        }
      } finally {
        fetchCoupon()
        setShowModal(false)
      }
    }
  }

  const deleteCoupon = async (id) => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/coupons/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json())
      if (response.status.code !== 0) throw new Error('Error delete coupon')
      customizeModal('ลบคูปองสำเร็จ', '', 'success')
    } catch (error) {
      customizeModal('ลบคูปองไม่สำเร็จ', 'เกิดข้อผิดพลาดในการลบคูปอง', 'error')
    } finally {
      fetchCoupon()
    }
  }

  const downloadCoupon = async (couponType) => {
    if (!couponType) {
      customizeModal('กรุณาเลือกประเภทคูปอง', '', 'error')
      return
    }

    try {
      await fetch(`${config.apiAdminGateway}/api/v1/admin/coupons/download?couponType=${couponType}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status !== 200) throw new Error(response.status)
          return response.blob()
        })
        .then((blobData) => {
          const url = window.URL.createObjectURL(new Blob([blobData]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `coupon-${couponType}-${new Date().toISOString()}.csv`)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        })
      customizeModal(`โหลดคูปองสำเร็จ ${couponType}`, '', 'success')
    } catch (error) {
      customizeModal('โหลดคูปองไม่สำเร็จ', 'เกิดข้อผิดพลาดในการโหลดคูปอง', 'error')
    } finally {
      fetchCoupon()
    }
  }

  const handleClickPagination = (isNext) => {
    const page = isNext ? searchParam.page + 1 : searchParam.page - 1
    setSearchParam((params) => ({ ...params, page: page }))
  }

  return (
    <PageContainer>
      <Card>
        <Card.Header>
          <Card.Title>คูปอง</Card.Title>
        </Card.Header>

        <Card.Body>
          <div>
            <form
              style={{
                display: 'flex',
                flexGrow: 1,
                gap: '16px',
                justifyContent: 'space-between',
                paddingBottom: '16px',
              }}
            >
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {searchParam.couponType || (searchParam.couponType === '' && 'ชนิดของคูปอง')}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {COUPON_TYPE.map((type) => (
                    <Dropdown.Item
                      key={type}
                      onClick={(e) => {
                        e.stopPropagation()
                        setSearchParam({ ...searchParam, couponType: type === 'ALL' ? '' : type })
                      }}
                    >
                      {type}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div style={{ display: 'flex', gap: '16px' }}>
                <Button variant="warning" onClick={() => setShowDownloadModal(true)}>
                  ดาวน์โหลดคูปอง
                </Button>

                <ButtonGroup>
                  <Button onClick={() => setShowModal(true)}>สร้างคูปอง</Button>
                </ButtonGroup>
              </div>
            </form>
          </div>
          <StyledTable>
            <thead>
              <tr>
                <th>วันที่สร้าง</th>
                <th>ชื่อ event</th>
                <th>รหัสคูปอง</th>
                <th>รหัสสมาชิก</th>
                <th>ประเภทคูปอง</th>
                <th>เครดิต</th>
                <th>แอดมิน</th>
                <th>จัดการคูปอง</th>
              </tr>
            </thead>
            <tbody>
              {couponDetail?.length > 0 ? (
                couponDetail.map((coupon) => {
                  return (
                    <tr key={coupon.id}>
                      <td>{moment(coupon.createdAt).format('DD/MM/YYYY')}</td>
                      <td>{coupon?.eventName ? coupon.eventName : ''}</td>
                      <td>{coupon.code}</td>
                      <td>{coupon.receiver.userNo}</td>
                      <td>{coupon.couponType}</td>
                      <td>{formatComma(coupon.amount)}</td>
                      <td>{coupon.createdBy.name}</td>
                      <td>
                        {coupon.receiver.userNo === '' && (
                          <Button
                            style={{
                              backgroundColor: 'red',
                              padding: '8px',
                              width: '100%',
                              cursor: `${coupon.downloadAt ? 'default' : 'pointer'}`,
                            }}
                            onClick={() => deleteCoupon(coupon.id)}
                            disabled={coupon.downloadAt}
                          >
                            ลบคูปอง
                          </Button>
                        )}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr style={{ pointerEvents: 'none' }}>
                  <td colSpan={99} style={{ textAlign: 'center', color: 'red', fontSize: '1.25rem' }}>
                    ไม่มีออเดอร์
                  </td>
                </tr>
              )}
            </tbody>
          </StyledTable>
        </Card.Body>
        <Card.Footer>
          <Pagination
            pagination={{ page: searchParam.page, hasNext: hasNextPage }}
            onClickPagination={handleClickPagination}
          />
        </Card.Footer>
      </Card>
      <CreateCouponModal showModal={showModal} setShowModal={setShowModal} createCouponByType={createCouponByType} />
      <DownloadModal
        showModal={showDownloadModal}
        setShowModal={setShowDownloadModal}
        downloadCoupon={downloadCoupon}
      />
    </PageContainer>
  )
}

export default Coupon
